import { LOCIZE_NS, BASE_URL } from '@avanta/shared/constants/common';
import { t } from '@avanta/shared/i18n';
import { service } from '@avanta/shared/services/api';
import { getUserId } from '@avanta/shared/utils/storage';

const CHANGE_PASSWORD_URL = `${BASE_URL}users`;

export interface ChangePasswordParams {
  currentPassword: string;
  newPassword: string;
}

export const changeUserPassword = async (params: ChangePasswordParams): Promise<void> => {
  const userId = getUserId();

  if (!userId) {
    throw new Error(t('ChangePassword.error.unauthenticated', { ns: LOCIZE_NS.PROFILE }));
  }

  try {
    await service.post(`${CHANGE_PASSWORD_URL}/${userId}/password`, {
      old_password: params.currentPassword,
      password: params.newPassword,
    });
  } catch {
    throw new Error(t('ChangePassword.error.generic', { ns: LOCIZE_NS.PROFILE }));
  }
};

export const ChangePasswordService = {
  changeUserPassword,
};
